import { ChipsideComponent } from "../chipside-component";

export class DropdownItem extends ChipsideComponent {
	static observedAttributes = ["value", "disabled", "link", "group"];

	constructor() {
		super();

		this.value = this.getAttribute("value");
		this.icon = this.getAttribute("icon") ?? "";
		this.identifier = this.getAttribute("identifier") ?? "";
		this.link = this.getAttribute("link") ?? "";
		this.target = this.getAttribute("target");
		this.group = this.getAttribute("group");
		this.detached = this.hasAttribute("detached");
	}

	parsedCallback() {
		if (this.icon) {
			this.prepend(document.createElementWithContents("i", null, {
				className: this.icon
			}));
		}
	}

	attributeChanged(name, _, newValue) {
		switch (name) {
			case "disabled":
				if (!this.IsAttributeValueTrue(newValue)) {
					this.parentElement.removeAttribute("disabled");
				} else {
					this.parentElement.setAttribute("disabled", "");
				}
				break;
			case "link":
				if (this.parentElement.nodeName === "A") {
					this.parentElement.href = newValue;
				}
				break;
		}
	}
}